import { config } from "./config";

type LogPayload = unknown;

function prefix(): string {
  return `[${config.appName}]`;
}

export const logger = {
  debug: (...args: LogPayload[]) => {
    if (config.isDev) console.debug(prefix(), ...args);
  },
  info: (...args: LogPayload[]) => {
    console.info(prefix(), ...args);
  },
  warn: (...args: LogPayload[]) => {
    console.warn(prefix(), ...args);
  },
  error: (...args: LogPayload[]) => {
    console.error(prefix(), ...args);
  },
};
